import React from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import './Demo.css'
import Developer from '../../Components/Developer/Developer'
export default function Demo() {
    return (
        <section className='demo'>
            <Banners />
            <Products />
            <Developer />
        </section>
    )
}
